import Vue from "vue";

const notify = (text, type, duration = 3000) => {
  Vue.notify({
    duration,
    group: "vera",
    title: "",
    text,
    type,
    position: "top"
  });
};

export default {
  info(text) {
    notify(text, "info");
  },
  error(text) {
    notify(text, "error");
  },
  errorWithDuration(text, duration) {
    notify(text, "error", duration);
  },
  success(text) {
    notify(text, "success");
  }
};
